import { type ThemeColors, colors, StyledIcon } from 'fitify-ui'
import {
  biggerPhone,
  phone,
  tabletPortrait,
} from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledWorkStatistics = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: start;
  justify-content: space-around;
  padding: 32px;
  border-radius: 24px;
  background-color: ${colors.White};

  ${biggerPhone(css`
    align-items: center;
    justify-content: center;
  `)}
`
export const StyledWorkStatisticsGrid = styled.div`
  position: relative;
  display: grid;
  flex-direction: row;
  margin: 40px 0;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: 1fr;

  ${tabletPortrait(css`
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: 1fr 1fr;
  `)}

  ${biggerPhone(css`
    grid-template-columns: 1fr 1fr;
    grid-template-rows: repeat(3, 1fr);
  `)}

  ${phone(css`
    grid-template-columns: 1fr;
    grid-template-rows: repeat(5, 1fr);
  `)}
`

export const StyledWorkStatisticsItem = styled.div<{ $iconColor: ThemeColors }>`
  display: flex;
  flex-direction: column;
  padding-left: 16px;
  border-right: 2px solid ${colors.Gray200};

  &:first-child {
    padding-left: 0;
  }
  &:last-child {
    border-right: none;
  }

  ${StyledIcon} {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
    color: ${({ $iconColor }) => colors[$iconColor]};
  }

  ${tabletPortrait(css`
    padding-bottom: 20px;
    &:first-child,
    &:nth-child(4) {
      padding-left: 0;
    }
    &:nth-child(3) {
      border-right: none;
    }
    &:last-child {
      border-right: 2px solid ${colors.Gray200};
    }
  `)}

  ${biggerPhone(css`
    &:nth-child(2n + 1) {
      padding-left: 0;
    }
    &:nth-child(2n) {
      border-right: none;
    }
    &:nth-child(4) {
      padding-left: 16px;
    }
    &:nth-child(3) {
      border-right: 2px solid ${colors.Gray200};
    }
    &:last-child {
      border-right: 2px solid ${colors.Gray200};
    }
  `)}

  ${biggerPhone(css`
    align-items: center;
    justify-content: center;
    padding: 8px 16px;
    text-align: center;
  `)}

  ${phone(css`
    align-items: flex-start;
    justify-content: center;
    border-bottom: 1px solid ${colors.Gray200};
    text-align: left;
    &:last-child {
      border-bottom: none;
    }
    &:nth-child(n) {
      padding-left: 0;
      border-right: none;
    }
  `)}
`
